/**
 * Fills [data-free-shipping-amount] spans (announcement bar, product page text) with the
 * free shipping threshold in the shopper's currency. Same conversion as free-shipping-bar.js:
 * store-currency threshold x window.Shopify.currency.rate.
 *
 * Rounded up to a whole unit and shown without decimals or thousands separators,
 * so it reads "€94" and "1064 kr" rather than "€93,65" and "1 064 kr".
 * The number is dropped into the currency's own money format, so symbol and position
 * (€94, 700 DKK, 1064 kr) still follow the store's settings.
 */
function renderFreeShippingAmounts() {
  const rate = Number(window.Shopify?.currency?.rate ?? 1);
  if (!rate) return;
  document.querySelectorAll('[data-free-shipping-amount]').forEach((el) => {
    const { thresholdCents, moneyFormat } = el.dataset;
    const converted = Number(thresholdCents) * rate;
    if (!converted) return;
    const whole = String(Math.ceil(converted / 100));
    const format = moneyFormat || '{{amount}}';
    el.textContent = format.replace(/\{\{\s*\w+\s*\}\}/, whole);
  });
}

renderFreeShippingAmounts();
